module.exports = __webpack_public_path__ + "KaTeX_Math-BoldItalic.e8e12d00.woff";